import { Component, inject } from '@angular/core';
import { AlertController, NavController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { AuthFacade } from 'src/app/store';

@Component({
    selector: 'app-side-menu-layout',
    templateUrl: './side-menu-layout.component.html',
    styleUrls: ['./side-menu-layout.component.scss']
})
export class SideMenuLayoutComponent {
    navCtrl = inject(NavController);
    alertController = inject(AlertController);
    translate = inject(TranslateService);
    authFacade = inject(AuthFacade);
    toastController = inject(ToastController);

    async logoutAccount() {
        const alert = await this.alertController.create({
            header: this.translate.instant('SIGN_OUT_CONFIRM.HEADER'),
            message: this.translate.instant('SIGN_OUT_CONFIRM.MESSAGE'),
            buttons: [
                {
                    text: this.translate.instant('CANCEL'),
                    role: 'cancel'
                },
                {
                    text: this.translate.instant('SIGN_OUT'),
                    role: 'confirm'
                }
            ]
        });

        await alert.present();

        const { role } = await alert.onDidDismiss();
        if (role === 'confirm') {
            this.logout();
        }
    }

    async logout(msg?: string) {
        await lastValueFrom(this.authFacade.logout());
        if (!this.authFacade.isAuth) {
            this.navCtrl.navigateRoot('/login');
            if (!msg) {
                msg = this.translate.instant('SIGN_OUT_CONFIRM.CONFIRM_MESSAGE');
            }

            this.presentToast(msg);
        }
    }

    async presentToast(message: string) {
        const toast = await this.toastController.create({
            message,
            duration: 1500,
            position: 'bottom',
            color: 'primary'
        });

        await toast.present();
    }
}
